module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, window, $) {
	'use strict';

	fox.registerWidget('Control_DropdownMultipleSelect', {

		configure: function (options) {

			this.registerOptions('', {
				template: 'control_dropdown_multiple_select',
				autoRender: true,
				container: '.dropdown-multiple-select',
				mainPlaceholder: 'Select something',
				itemsPlaceholder: 'No selected items...',
				widgets: {
					listApi: {
						widget: 'Datalayer',
						method: 'category.get',
						//fields: ['id', 'alias', 'name', 'orientations.alias', 'orientations.id'],
						limit: 0
					},
					list: {
						widget: 'List',
						autoRender: false,
						manualRender: true,
						'tpl.row': 'control_dropdown_multiple_select_list_item',
						embed: {
							container: '.list-container'
						}
					},
					selectedItemsList: {
						widget: 'List',
						autoRender: false,
						manualRender: true,
						tpl: {
							row: 'control_dropdown_multiple_select_list_selected_item',
							emptyRow: 'control_dropdown_multiple_select_list_selected_item_empty',
						},
						embed: {
							container: '.tags-list.all'
						}
					},
					total: {
						widget: 'Widget',
						autoRender: true,
						template: 'control_dropdown_multiple_select_list_total_item',
						embed: {
							container: '.tags-list.total-wrapper'
						}
					}
				},
				handleWom: {
					apiHandler: {
						widget: '#listApi',
						event: ['success', 'loaded'],
						callback: '_handleApiResponse'
					},

					/*applyScroll: {
						widget: '#list',
						event: 'addedToDom',
						callback: function (obj, w, e) {
							$(w.element[0]).mCustomScrollbar({
								theme: 'minimal-dark'
							});
						}
					}*/
				},
				handleDom: {
					preventListWrapperClick: {
						target: '.dropdown-list',
						event: 'click',
						callback: function (el, alias, w, e) {
							if (fox.isFunction(e.stopPropagation)) {
								e.stopPropagation();
							} else {
								e.cancelBubble = true;
							}

							return false;
						}
					},
					toggleDropdown: {
						target: '.mc-tag-selector',
						event: 'click',
						callback: '_toggle'
					},

					select: {
						targetWidget: '#list',
						target: 'input[type="checkbox"]',
						event: 'change',
						callback: '_select'
					},
					clear: {
						targetWidget: '#total',
						target: '.delete',
						event: 'click',
						callback: '_clear'
					},
					remove: {
						targetWidget: '#selectedItemsList',
						target: '.delete',
						event: 'click',
						callback: '_remove'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.isOpened = false;
			this.isDataExists = false;

			this.selectedList = [];
			this.data = [];

			this.callParent('init', arguments);
		},

		running: function () {
			this.api = this.wom1('#listApi');
			this.list = this.rwom1('#list');
			this.selectedItemsList = this.rwom1('#selectedItemsList');
			this.totalWidget = this.rwom1('#total');

			this.selectedItemsList.setTemplateOptions('placeholder', this.getOption('itemsPlaceholder'));
			this.totalWidget.setTemplateOptions('placeholder', this.getOption('mainPlaceholder'));

			this.loadList();

			this.callParent('running', arguments);
		},

		deactivate: function () {
			this._unbindWindowEvents();
			this.clear();

			this.callParent('deactivate', arguments);
		},

		activate: function () {
			this.callParent('activate', arguments);
			this.loadList();
		},

		_bindWindowEvents: function (el) {
			$(document).on('click keyup', {widget: this, el: el}, this._hideDropdownList);
		},

		_unbindWindowEvents: function () {
			$(document).off('click keyup', this._hideDropdownList);
		},

		apiIsDl: function () {
			return fox.oop.instanceOf(this.api, 'Datalayer');
		},

		loadList: function () {
			if (!this.api) {
				return;
			}

			this.hookWrapper('prepareSendParams');

			if (this.apiIsDl()) {
				this.api.load();

				return;
			}

			this.api.send(this._sendParams);
		},

		prepareSendParams: function (argument) {
			this._sendParams = {};
		},

		prepareResponse: function (response) {},

		showDropdownList: function (argument) {
			if (this.isDataExists) {
				fox.dom.addClass('opened', this.getMainElement());
				this.isOpened = true;
			}
		},

		_hideDropdownList: function (e) {
			var container = $(e.data.el);

			if (e.type === 'keyup') {
				if (e.keyCode && e.keyCode === 27) {
					e.data.widget.hideDropdownList();
				}

				return;
			}

			if (!container.is(e.target) &&
				container.has(e.target).length === 0 &&
				e.data.widget.isOpened) {
					e.data.widget.hideDropdownList();
			}
		},

		hideDropdownList: function (argument) {
			fox.dom.removeClass('opened', this.getMainElement());
			this.isOpened = false;
		},

		_toggle: function (el, alias, w, e) {
			if (this.isOpened) {
				this.hideDropdownList();
				this._unbindWindowEvents();

				return;
			}

			this.showDropdownList();
			this._bindWindowEvents(el);
		},

		getMainElement: function (argument) {
			return this.dom1('.mc-tag-selector');
		},

		_handleApiResponse: function (response, w, e) {
			var data = this.apiIsDl() ? w.getCollection() : response.answer.response;

			if (fox.isObject(data)) {
				data = fox.toArray(data);
			}

			this.hookWrapper('prepareResponse', data);

			this.setData(data);

			this.renderList(data);
			this.selectedItemsList.setCollection([], true);
			this.totalWidget.render();

			this.dispatchEvent('apiLoaded', {data: data});
		},

		setData: function (data) {
			this.isDataExists = false;
			this.data = data;

			if (this.data.length) {
				this.isDataExists = true;
			}

			this.dispatchEvent('dataSetted', {data: data});
		},

		renderList: function (data) {
			this.list.setCollection(data, true);
		},

		renderTotalWidget: function () {
			var count = fox.count(this.selectedItemsList.collection);

			this.totalWidget.setTemplateOptions('count', null);

			if (count !== 0) {
				this.totalWidget.setTemplateOptions('count', count);
			}

			this.totalWidget.render();
		},

		_select: function (elm) {
			if (elm.checked === true) {
				this.addToSelectedList(window.parseInt(elm.getAttribute('item-id')));

				return;
			}

			this.removeFromSelectedList(window.parseInt(elm.getAttribute('item-id')));
		},

		addToSelectedList: function (id) {
			this.selectedList.push(id);

			this.modifyDataObject(id, true);

			this.renderSelectedList();
			this.dispatchEvent('change', this.selectedList);
		},

		removeFromSelectedList: function (id) {
			var ind = this.selectedList.indexOf(id);

			if (ind !== -1) {
				this.selectedList.splice(ind, 1);

				this.modifyDataObject(id, false);

				this.renderSelectedList();
				this.dispatchEvent('change', this.selectedList);
			}
		},

		renderSelectedList: function () {
			var data = this.data.filter(function (item) {
				if (fox.inArray(this.selectedList, item.id)) {
					return item;
				}
			}.bind(this));

			this.selectedItemsList.setCollection(data, true);
			this.renderTotalWidget();
		},

		_clear: function (el, alias, w, e) {
			if (fox.isFunction(e.stopPropagation)) {
				e.stopPropagation();
			} else {
				e.cancelBubble = true;
			}

			this.clear();

			return false;
		},

		clear: function () {
			this.modifyDataObject(this.selectedList, false);

			this.selectedList = [];

			this.renderSelectedList();
			this.renderList(this.data);

			this.dispatchEvent('change', this.selectedList);
		},

		_remove: function (elm) {
			this.removeFromSelectedList(window.parseInt(elm.getAttribute('item-id')));
			this.renderList(this.data);
		},

		modifyDataObject: function (ids, state) {
			if (!fox.isArray(ids)) {
				ids = [ids];
			}

			fox.each(this.data, function (item) {
				if (fox.inArray(ids, item.id)) {
					if (state === true) {
						item.selected = true;

						return;
					}

					delete item.selected;
				}
			}.bind(this));
		},

		getValue: function () {
			return this.selectedList;
		}

	}, 'Widget');

})(fox, window, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/dropdownMultipleSelect.js
// module id = 297
// module chunks = 2